const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];

import intlTelInput from 'intl-tel-input';

export function ValidatePhones(selector, tooltip){

    function init_tel_validation(inputs)
    {
        const iti = intlTelInput(inputs, {
            preferredCountries: ['us', 'mx', 'es',],
            utilsScript: '/js/utils.js',
            formatOnDisplay: false
        });

        const reset = function (e) {
            e.target.classList.remove("is_invalid");
            const t = tooltip.getInstance(e.target);
            if (t) t.dispose();
        };

        // on blur: validate
        inputs.addEventListener('blur', function(e) {
            reset(e);
            const input = e.target;
            if (input.value.trim()) {
                if (iti.isValidNumber()) {
                    // input.value = iti.getNumber()
                } else {
                    input.classList.add("is_invalid");
                    const errorCode = iti.getValidationError();
                    new tooltip(input, {
                        title: errorMap[errorCode] || 'Incorrect number',
                        trigger: 'manual',
                        placement: 'right'
                    }).show();
                }
            }
        });

// on keyup / change flag: reset
        inputs.addEventListener('change', reset);
        inputs.addEventListener('keyup', reset);
    }

    document.querySelectorAll(selector).forEach(init_tel_validation);
}

